import React from 'react';
import { TipsMapFunType, TipsMapType } from '../index';
import { GPTSummaryDemoUrlCh, GPTSummaryDemoUrlEn } from './utils';
import {
  gptOptionsCnTextMap,
  gptOptionsTextMap,
} from '@op/components/GPT/constants';
import { CONTACT_EMAIL, CONTACT_NAME } from '@op/constants';
export const aigcPromptTips: TipsMapType = {
  en: `Please enter text to instruct AI how to summarize the content.`,
  zh: '请在文本框输入要求，指示AI如何总结内容。',
};

export const aigcDeepseekAnalysisTargetPromptTips: TipsMapType = {
  en: (
    <>
      Input relevant background knowledge or key focus areas here to generate a
      more tailored summary.
      <br />
      Note: Format restrictions or specific template requests may cause
      processing issues.
    </>
  ),
  zh: (
    <>
      输入相关的背景知识或重点关注领域，以便生成更加定制化的摘要。
      <br />
      注意：格式限制或特定模板请求可能会导致处理问题。
    </>
  ),
};

export const aigcDownloadTips: TipsMapType = {
  en: `The AI Summary file will be downloaded to your local device in a new page. You do not need to stay on the current page.`,
  zh: '将在新页面下载该报告文件到本地，您无需停留在当前页面。',
};

export const aigcGptReportTips: TipsMapType = {
  en: `Generate a AI public sentiment report based on your selected time`,
  zh: '将在新页面下载该报告文件到本地，您无需停留在当前页面。',
};

export const aigcGPTOptionsTips: TipsMapType = {
  en: (
    <div style={{ maxWidth: '380px' }}>
      <b>Summary Agent</b>
      <br />
      Using the Gemini model for AI summarization.
      <br />
      <b>{gptOptionsTextMap.basic}</b>
      <br />
      Provides a quick and concise overview of opinions, summarizing the main
      positive and negative feedback points.
      <br />
      <b>{gptOptionsTextMap.advanced}</b>
      <br />
      Provides detailed opinion summary on positive and negative player
      feedback, supplemented with specific data statistics. Each opinion will
      display the number of player comments and engagement data (such as likes).
      <br />
      To ensure the effectiveness of the summary, neutral and invalid comments
      are not analyzed by default.
      <br />
      <br />
      {GPTSummaryDemoUrlEn}
    </div>
  ),
  zh: (
    <div style={{ maxWidth: '380px' }}>
      <b>总结模型</b>
      <br />
      使用Gemini模型做AI总结。
      <br />
      <b>{gptOptionsCnTextMap.basic}</b>
      <br />
      提供快速且简洁的舆情概述，将总结出主要的正面和负面反馈要点。
      <br />
      <b>{gptOptionsCnTextMap.advanced}</b>
      <br />
      提供正面、负面玩家反馈的详细观点，并附加具体的观点数据统计。每个观点都将展示玩家的具体评论数及互动数据（如点赞数）。
      <br />
      为保证当前总结效果，中性评论及无效评论默认不进行分析。
      <br />
      <br />
      {GPTSummaryDemoUrlCh}
    </div>
  ),
};

export const aigcAdvancedSummaryTips: TipsMapFunType = (value: number) => ({
  en: (
    <>
      DataBrain offers a system-wide daily free quota of {value} advanced
      summaries to all users. If you have any questions, feel free to contact{' '}
      {CONTACT_EMAIL}
    </>
  ),
  zh: (
    <>
      DataBrain 系统全局每日提供{value}
      次免费高级版总结，如有任何疑问请联系{CONTACT_EMAIL}。
    </>
  ),
});

export const aigcGptModalTypeTips: TipsMapType = {
  en: <>Using the Gemini model for AI summarization.</>,
  zh: <>使用Gemini模型做AI总结</>,
};

export const aigcGenerateRepeatTips: TipsMapType = {
  en: `You do not currently have permission to set up recurring reports; please contact ${CONTACT_NAME}(${CONTACT_EMAIL}) if necessary.`,
  zh: `您目前没有设置例行报告的权限，如有需要请联系${CONTACT_NAME}(${CONTACT_EMAIL}).`,
};